import enUS from 'antd/locale/en_US';
import zhTW from 'antd/locale/zh_TW';
import zhCN from 'antd/locale/zh_CN';
import 'dayjs/locale/en';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/vi';
import vi from 'antd/locale/vi_VN';
import type { OptionsArrayKeys } from '@/scripts/extends';
import { OptionsArray } from '@/scripts/extends';
import languageMap from './locales';
// Map
export { languageMap };

// List
export const languageList = new OptionsArray([
  {
    key: 'en',
    label: 'English',
    antdPackage: enUS,
    dayjsKey: 'en',
  },
  {
    key: 'zh-CN',
    label: '简体中文',
    antdPackage: zhCN,
    dayjsKey: 'zh-cn',
  },
  {
    key: 'zh-TW',
    label: '繁体中文',
    antdPackage: zhTW,
    dayjsKey: 'zh-tw',
  },
  {
    key: 'vi',
    label: 'Tiếng Việt',
    antdPackage: vi,
    dayjsKey: 'vi',
  },
] as const);

export type LanguageListKeys = OptionsArrayKeys<typeof languageList>;

languageList.forEach((item) => {
  if (!(item.value in languageMap)) {
    console.error(
      `The configuration item whose key is '${item.key}' is missing from the language list.`
    );
  }
});
